export { DiscountBadge } from './index.pc'
export { MobileDiscountBadge } from './index.mobile'
